import React, { useEffect, useImperativeHandle, useState } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'
import { StripeCardElementChangeEvent } from '@stripe/stripe-js'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js'

export interface StripeRef {
  createToken?: () => any
}

export interface CardInputProps  {
  onChange: (event: StripeCardElementChangeEvent) => void
}

export const CardInput = React.forwardRef<StripeRef, CardInputProps>(({ onChange, ...props }, ref) => {
  const stripe = useStripe()
  const elements = useElements()

  const [addedListener, setAddedListener] = useState(false)

  useEffect(() => {
    if (elements && !addedListener) {
      const cardElement = elements.getElement('card')
      if (cardElement) {
        cardElement.on('change', (event) => {
          onChange(event)
        })
        setAddedListener(true)
      }
    }
  }, [elements, addedListener, onChange])

  useImperativeHandle(ref, () => ({
    createToken: () => {
      if (stripe && elements) {
        const cardElement = elements.getElement('card')
        if (cardElement) {
          return stripe.createToken(cardElement)
        }
      }
      return null
    }
  }))

  const theme = useTheme()

  const style = {
    base: {
      fontFamily: 'Assistant, sans-serif',
      fontSize: '14px',
      color: theme.brand.neutral,
      iconColor: theme.brand.action,
      '::placeholder': {
        color: theme.brand.light
      }
    },
    invalid: {
      color: theme.brand.negative,
      iconColor: theme.brand.negative
    }
  }

  return (
    <CardInputWrapper {...props}>
      <CardElement options={{ style }} />
    </CardInputWrapper>
  )
})

const CardInputWrapper = styled.div`
  height: var(--space--xl);
  border: 1px solid var(--colors-subtle);
  border-radius: var(--border-radius--xxs);
  padding: 8px 0 0 12px;
`
